export default __webpack_public_path__ + "jenny.2819b2f9.jpg";